// Fire-and-forget click beacons. Uses sendBeacon when available, falls back
// to fetch keepalive. Never awaits, never throws — must not block the click.
const RAW = process.env.REACT_APP_BACKEND_URL || "";
const URL = `${RAW.replace(/\/$/, "")}/api/analytics/click`;

export function trackClick(event, source) {
  try {
    const body = JSON.stringify({ event, source });
    const blob = new Blob([body], { type: "application/json" });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(URL, blob);
      return;
    }
    fetch(URL, {
      method: "POST",
      body,
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      credentials: "omit",
    }).catch(() => {});
  } catch {}
}

export const trackWa = (source) => trackClick("whatsapp_click", source);
export const trackOf = (source) => trackClick("onlyfans_click", source);
export const trackCall = (source) => trackClick("phone_click", source);
